import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import { useDispatch } from 'react-redux'
import { signOutUser } from '../../actions/authActions'
import Placeholder from './Placeholder'
import { useTranslation } from 'react-i18next'

const modalStyles = {
  content: {
    height: '460px',
    width: '30%',
    marginTop: '12%',
    overflow: 'hidden',
  },
}

const CommunityBlockModal = ({ showModal }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const signOut = useCallback(
    () => {
      dispatch(signOutUser())
    },
    [ dispatch ]
  )

  return (
    <Modal
      style={modalStyles}
      isOpen={showModal}
      contentLabel={t('common.communityBlockModal.contentLabel')}
    >
      <div className='modal-content animated fadeIn'>
        <div className='my-3'>
          <div className='col-12 mx-auto'>
            <Placeholder
              title={t('common.communityBlockModal.title')}
              icon={'fa-ban'}
              subtext1={t('common.communityBlockModal.subtext1')}
              subtext2={t('common.communityBlockModal.subtext2')}
              buttonText={t('common.communityBlockModal.signOut')}
              buttonIcon={'fa-sign-out'}
              handleClick={signOut}
            />
          </div>
        </div>
      </div>
    </Modal>
  )
}

CommunityBlockModal.propTypes = {
  showModal: PropTypes.bool,
}

export default CommunityBlockModal
